import { IUserServiceMock } from "./user.types";

export const mockUserService = (): IUserServiceMock => ({
  fetchMe: jest.fn(),
  updateMe: jest.fn(),
});
